var fowtr_module_fullscreen = (function (fowtr_module_fullscreen) {

      
      // ============================================================================================
      // FULLSCREEN SWITCH
      // ============================================================================================

      $('#fowtr-wrapper').on('click', '#fowtr-navigation .fowtr-fullscreen-toggle, #fowtr-tutorial .fowtr-tutorial-fullscreen-toggle', function(event) {
        event.preventDefault();
        var elem = document.documentElement;
        // hide the tutorial popup
        $('#fowtr-tutorial .fowtr-tutorial-fullscreen').hide();
        // (put any functions in the handler below to catch escape key)
          if(!$('body').hasClass('fowtr-fullscreen')){
            //enter full screen
            if (elem.requestFullscreen) {
              elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
              elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
              elem.msRequestFullscreen();
            }
          } else {
            // exit fullscreen 
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          }
      });

      // exit handler (needed caus can press escape key to exit as well)
      if (document.addEventListener){
       document.addEventListener('fullscreenchange', fullScreenHandler, false);
       document.addEventListener('mozfullscreenchange', fullScreenHandler, false);
       document.addEventListener('MSFullscreenChange', fullScreenHandler, false);
       document.addEventListener('webkitfullscreenchange', fullScreenHandler, false);
      }

      function fullScreenHandler(){
       if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        // console.log('exiting fullscreen mode');
        $('body').removeClass('fowtr-fullscreen');
        $('#fowtr-wrapper').removeClass('fowtr-fullscreen');
        // fowtr_module_navigation.stickyNavStuff();
        // setTimeout(function(){
        //   fowtr_module_navigation.stickyNavStuff();
        // },2000);
       } else {
        // console.log('entering fullscreen mode');
        $('body').addClass('fowtr-fullscreen');
        $('#fowtr-wrapper').addClass('fowtr-fullscreen');
       }
      }



    fowtr_module_fullscreen.init = function(chapter){

      // console.log('fowtr_module_fullscreen initialised');


    };

    return fowtr_module_fullscreen;
}(fowtr_module_fullscreen || {}));